import React from 'react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="terms-container">
      <h1 className="terms-title">{t('header.privacy')}</h1>
      <p><strong>{t('header.privacy_effective')}</strong> 03 May 2025</p>
      <p>{t('header.privacy_intro')}</p>

      <h2>{t('header.privacy_1_title')}</h2>
      <p>{t('header.privacy_1_text1')}</p>
      <p><a href="mailto:contact@aryam-ars.com" style={{color: '#568259', textDecoration: 'underline'}}>contact@aryam-ars.com</a><br/>
      <a href="https://aryam-ars.com/" target="_blank" rel="noopener noreferrer">https://aryam-ars.com/</a></p>

      <h2>{t('header.privacy_2_title')}</h2>
      <p>{t('header.privacy_2_text1')}</p>
      <ul style={{ listStyleType: 'disc', marginLeft: 24 }}>
        <li>{t('header.privacy_2_list1')}</li>
        <li>{t('header.privacy_2_list2')}</li>
        <li>{t('header.privacy_2_list3')}</li>
        <li>{t('header.privacy_2_list4')}</li>
        <li>{t('header.privacy_2_list5')}</li>
        <li>{t('header.privacy_2_list6')}</li>
        <li>{t('header.privacy_2_list7')}</li>
        <li>{t('header.privacy_2_list8')}</li>
        <li>{t('header.privacy_2_list9')}</li>
        <li>{t('header.privacy_2_list10')}</li>
        <li>{t('header.privacy_2_list11')}</li>
      </ul>
      <p>{t('header.privacy_2_text2')}</p>
      <ul style={{ listStyleType: 'disc', marginLeft: 24 }}>
        <li>{t('header.privacy_2_cond1')}</li>
        <li>{t('header.privacy_2_cond2')}</li>
        <li>{t('header.privacy_2_cond3')}</li>
        <li>{t('header.privacy_2_cond4')}</li>
      </ul>

      {i18n.resolvedLanguage?.startsWith('fr') ? (
        <section aria-labelledby="android-privacy-title">
          <h2 id="android-privacy-title">Application Android et utilisation hors connexion</h2>
          <p>UpyaChat conserve sur le téléphone les conversations déjà consultées et les notes, contextes de projet, photos et documents préparés hors connexion. Ces éléments restent accessibles sans réseau et sont synchronisés avec nos services quand la connexion revient. Ils restent sur l’appareil jusqu’à l’effacement des données de l’application ou sa désinstallation.</p>
          <p>Lorsque vous utilisez le chat ou synchronisez un projet, les questions, réponses et contenus que vous avez choisis sont transmis à nos services hébergés chez Scaleway. Les fonctions d’intelligence artificielle et de transcription utilisent OpenAI. Les coordonnées GPS ne sont demandées que si vous choisissez « Utiliser ma position » dans la météo ; elles sont transmises à nos services pour obtenir les prévisions auprès d’Open-Meteo. Vous pouvez à la place saisir une ville. Le microphone est facultatif : si vous l’autorisez et enregistrez une question, l’audio est transmis pour transcription. Vous pouvez toujours écrire votre question au clavier.</p>
          <p>Les échanges avec nos services utilisent une connexion HTTPS. Pour demander la suppression du compte et de ses données côté serveur, consultez <a href="/data-deletion">la procédure de suppression UpyaChat</a>. Les copies hors ligne sur le téléphone doivent être effacées séparément depuis les paramètres Android ou par désinstallation.</p>
        </section>
      ) : (
        <section aria-labelledby="android-privacy-title">
          <h2 id="android-privacy-title">Android app and offline use</h2>
          <p>UpyaChat saves conversations you have already viewed and notes, project context, photos and documents prepared offline on your phone. These items remain available without a network connection and sync with our services when connectivity returns. They remain on the device until you clear the app data or uninstall the app.</p>
          <p>When you use chat or sync a project, your questions, answers and chosen content are sent to our services hosted by Scaleway. AI and transcription features use OpenAI. GPS coordinates are requested only if you choose “Use my location” in the weather widget; they are sent to our services to obtain forecasts from Open-Meteo. You can enter a city instead. The microphone is optional: if you allow it and record a question, the audio is sent for transcription. You can always type your question.</p>
          <p>Connections to our services use HTTPS. To request deletion of your account and server-side data, see the <a href="/data-deletion">UpyaChat data deletion procedure</a>. Offline copies on the phone must be cleared separately in Android settings or by uninstalling the app.</p>
        </section>
      )}

      <h2>{t('header.privacy_why_title')}</h2>
      <p>{t('header.privacy_why_intro')}</p>
      <ul style={{ listStyleType: 'disc', marginLeft: 24 }}>
        <li>{t('header.privacy_why_list1')}</li>
        <li>{t('header.privacy_why_list2')}</li>
        <li>{t('header.privacy_why_list3')}</li>
        <li>{t('header.privacy_why_list4')}</li>
        <li>{t('header.privacy_why_list5')}</li>
        <li>{t('header.privacy_why_list6')}</li>
        <li>{t('header.privacy_why_list7')}</li>
        <li>{t('header.privacy_why_list8')}</li>
        <li>{t('header.privacy_why_list9')}</li>
        <li>{t('header.privacy_why_list10')}</li>
        <li>{t('header.privacy_why_list11')}</li>
      </ul>

      <h2>{t('header.privacy_5_title')}</h2>
      <ul>
        <li>{t('header.privacy_5_list1')}</li>
        <li>{t('header.privacy_5_list2')}</li>
        <li>{t('header.privacy_5_list3')}</li>
        <li>{t('header.privacy_5_list4')}</li>
        <li>{t('header.privacy_5_list5')}</li>
        <li>{t('header.privacy_5_list6')}</li>
      </ul>
      <p>{t('header.privacy_5_exercise')} <a href="mailto:contact@aryam-ars.com" style={{color: '#568259', textDecoration: 'underline'}}>contact@aryam-ars.com</a></p>
      <p>{t('header.privacy_5_delay')}</p>
      <p><a href="/data-deletion" style={{color: '#568259', textDecoration: 'underline'}}>
        {i18n.resolvedLanguage?.startsWith('fr')
          ? 'Demander la suppression des données UpyaChat'
          : 'Request deletion of your UpyaChat data'}
      </a></p>

      <h2>{t('header.privacy_6_title')}</h2>
      <p>{t('header.privacy_6_text1')}</p>
      <p>{t('header.privacy_6_text2')}</p>
      <ul>
        <li>{t('header.privacy_6_list1')}</li>
        <li>{t('header.privacy_6_list2')}</li>
      </ul>

      <h2>{t('header.privacy_7_title')}</h2>
      <p>{t('header.privacy_7_text')}</p>

      <h2>{t('header.privacy_8_title')}</h2>
      <p>{t('header.privacy_8_text')}</p>

      <h2>{t('header.privacy_9_title')}</h2>
      <p>{t('header.privacy_9_text')}</p>

      <h2>{t('header.privacy_10_title')}</h2>
      <p>{t('header.privacy_10_text')}</p>

      <h2>{t('header.privacy_11_title')}</h2>
      <p>{t('header.privacy_11_text')}</p>

      <h2>{t('header.privacy_12_title')}</h2>
      <p>{t('header.privacy_12_text1')}</p>
      <a href="https://edpb.europa.eu/about-edpb/board/members_en" target="_blank" rel="noopener noreferrer">https://edpb.europa.eu/about-edpb/board/members_en</a>

      <h2>{t('header.privacy_13_title')}</h2>
      <p>{t('header.privacy_13_text1')}</p>
      <p>{t('header.privacy_13_text2')}</p>
    </div>
  );
};

export default PrivacyPolicy; 
